<template>
  <div>
    <b-modal
      id="subscription-details-modal"
      ref="detailsModal"
      title="Subscription Details"
      :busy="modalLoading"
      hide-footer
    >
      <b-spinner
        v-if="modalLoading"
        variant="primary"
      />
      <div v-if="subscriptionDetails && !modalLoading">
        <p><strong>ID:</strong> {{ subscriptionDetails.id }}</p>
        <p><strong>Name:</strong> {{ subscriptionDetails.firstName + " " + subscriptionDetails.lastName }}</p>
        <p><strong>Type:</strong> {{ subscriptionDetails.plan.target }}</p>
        <p><strong>Status:</strong> {{ snakeCaseToCamelCase(subscriptionDetails.state) }}</p>
        <p><strong>Plan:</strong> {{ subscriptionDetails.plan.name }}</p>
        <p><strong>Next Payment Date:</strong> {{ dateFormat(subscriptionDetails.next_payment_date) }}</p>
        <p><strong>Created At:</strong> {{ dateFormat(subscriptionDetails.created_at) }}</p>
        <p><strong>End Date:</strong> {{ dateFormat(subscriptionDetails.end_date) }}</p>
        <b-button
          v-if="subscriptionDetails.state !== 'pending_cancellation'"
          variant="danger"
          class="mt-1"
          :disabled="cancelling"
          @click="cancelSubscription"
        >
          <b-spinner
            v-if="cancelling"
            small
          />
          Cancel Subscription
        </b-button>
      </div>
    </b-modal>
    <b-card>
      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="loading"
      >
        <b-row class="mb-1">
          <b-col md="4">
            <label
              for="target"
              class="mr-1"
            >Search by user type</label>
            <v-select
              id="target"
              v-model="currTarget"
              :clearable="false"
              :options="targetOptions"
              :reduce="(val) => val.key"
              @input="search"
            />
          </b-col>
          <b-col md="4">
            <label
              for="target"
              class="mr-1"
            >Search by status</label>
            <v-select
              id="target"
              v-model="currStatus"
              :clearable="false"
              :options="statusOptions"
              :reduce="(val) => val.key"
              @input="search"
            />
          </b-col>
          <b-col md="4">
            <label
              for="target"
              class="mr-1"
            >Search by bundle name</label>
            <b-form-input v-model="queryParams.name" />
          </b-col>
          <b-col
            class="d-flex justify-content-end align-items-center mt-2"
            md="12"
          >
            <b-button
              variant="primary"
              class="mr-1"
              @click="fetchUsers"
            >
              Search
            </b-button>
            <b-button
              class="btn-icon rounded-circle"
              variant="flat-primary"
              @click="fetchUsers"
            >
              <feather-icon icon="RefreshCwIcon" />
            </b-button>
          </b-col>
        </b-row>
        <b-table
          fixed
          :fields="tableColumns"
          :items="list"
          class="mb-2 text-center"
          show-empty
          empty-text="No matching records found"
        >
          <template #cell(actions)="data">
            <b-button
              variant="flat-primary"
              class="btn-icon rounded-circle"
              @click="openSubscriptionModal(data.item.id)"
            >
              <feather-icon icon="EyeIcon" />
            </b-button>
          </template>
        </b-table>
        <base-pagination
          v-model="queryParams.page"
          :total="total"
          @input="fetchUsers"
          @new-per-page="queryParams.perPage = $event"
        />
      </b-overlay>
    </b-card>
  </div>
</template>

<script>

import {
  BButton, BTable, BCard, BOverlay, BFormInput,
  BRow, BCol, BModal, BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import useSubscribedUsers from '../hooks/use-subscribed-users'
import BasePagination from '@/UI/BasePagination.vue'
import snakeCaseToCamelCase from '@/utils/snake-case-to-camcel-caase'
import { dateFormat } from '@/utils/date-format'

export default {
  components: {
    BButton,
    BFormInput,
    BModal,
    BasePagination,
    BSpinner,
    BTable,
    BCard,
    BOverlay,
    vSelect,
    BRow,
    BCol,
  },
  setup(_, ctx) {
    return {
      dateFormat,
      snakeCaseToCamelCase,
      ...useSubscribedUsers(ctx),

    }
  },
}
</script>
